var _rect, _g, _rect2, _rect3, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 500,
    viewBox: "0 0 303 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    width: 500,
    height: 303,
    rx: 80,
    transform: "rotate(90 303 0)",
    fill: "url(#paint0_radial_156_852)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_156_852)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 9,
    width: 482,
    height: 285,
    rx: 71,
    transform: "rotate(90 294 9)",
    stroke: "url(#paint1_linear_156_852)",
    strokeWidth: 18
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 282.88,
    y: 20,
    width: 460,
    height: 262.761,
    rx: 60,
    transform: "rotate(90 282.88 20)",
    stroke: "url(#paint2_linear_156_852)",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 264.25,
    y: 34.3335,
    width: 431,
    height: 225.498,
    rx: 45,
    transform: "rotate(90 264.25 34.3335)",
    stroke: "url(#paint3_linear_156_852)",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 259.782,
    y: 38.2192,
    width: 423.561,
    height: 216.564,
    rx: 41.5,
    transform: "rotate(90 259.782 38.2192)",
    stroke: "url(#paint4_linear_156_852)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_156_852",
    x: 0,
    y: -0.00000762939,
    width: 303,
    height: 500,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_156_852"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_156_852",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(553 151.5) rotate(90) scale(406.87 376.193)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FC653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_156_852",
    x1: 279.306,
    y1: 151.5,
    x2: 832.497,
    y2: 151.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_156_852",
    x1: 262.892,
    y1: 151.38,
    x2: 776.254,
    y2: 151.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18242A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_156_852",
    x1: 244.73,
    y1: 147.083,
    x2: 723.794,
    y2: 147.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_156_852",
    x1: 240.163,
    y1: 146.501,
    x2: 709.89,
    y2: 146.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213928"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.4c18eaf187cb55df6ad816a4f87e8104.svg";
export { ForwardRef as ReactComponent };